// Path: ./src/utils/dateUtil/setTimeTo1159PM.ts
export function setValidationEndTimeTo1159PM(date: Date | string): Date {
  // Convert string to Date if necessary
  const inputDate = typeof date === "string" ? new Date(date) : date;

  // Clone the date to avoid mutating the original date
  const torontoDate = new Date(inputDate.getTime());

  // Add one day
  torontoDate.setDate(torontoDate.getDate());

  // Set time to 11:59PM in Toronto's local time
  torontoDate.setHours(23, 59, 0, 0);

  // Find out the UTC offset for Toronto at that date
  const formatter = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/Toronto",
    hour12: false,
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    timeZoneName: "short",
  });

  // Get the formatted time string and extract the offset
  const parts = formatter.formatToParts(torontoDate);
  const offsetPattern = parts
    .find((part) => part.type === "timeZoneName")
    ?.value.match(/GMT([+-]\d{2})(\d{2})/);

  // Calculate the offset in minutes
  const offsetMinutes = offsetPattern
    ? parseInt(offsetPattern[1]) * 60 + parseInt(offsetPattern[2])
    : 0;

  // Convert Toronto time to UTC
  torontoDate.setMinutes(torontoDate.getMinutes() - offsetMinutes);

  return torontoDate;
}
